import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import { Link } from '@router/Link';

import useNickname from './hooks/useNickname';
import styles from './styles.module.scss';

function AccountManagement() {
  const {
    nickname, setNickname, handleUpdateNickname,
  } = useNickname();
  return (
        <Accordion title='회원정보 관리'>
            <Column className={styles.contents}
                    spacing={24} >
                <Column spacing={8} fullWidth>
                    <Text color={colors.gray6}
                          fontWeight='bold'
                          size='s'>닉네임</Text>
                    <div className={styles.nickname}>
                        <TextField value={nickname}
                                   maxLength={16}
                                   onChange={(e) => setNickname(e.target.value)}
                                   trailing={<Text className={styles.nicknameButton}
                                                   onClick={handleUpdateNickname}
                                                   fontWeight='bold' color={colors.primary} >
                                       변경
                                   </Text>} />
                    </div>
                </Column>
                {/*
                <Column spacing={8}>
                    <Text color={colors.gray6}
                          fontWeight='bold'
                          size='lg'>생년월일</Text>
                    <Text>설정하기</Text>
                </Column>
                */}
                {/*
                <Link activityName='AccountTerminationActivity'
                      activityParams={{}}>
                    <Text color={colors.gray6}
                          className={styles.termination}
                          size='lg'
                          fontWeight='bold' >
                        회원탈퇴 하기
                    </Text>
                </Link>
                */}
            </Column>
        </Accordion>
  );
}

export default AccountManagement;
